<div class="volume-control-container">
  <bmcore-button (click)="toggleMuteSound()" styleName="icon-40">
    @if (value === 0) {
      <bmcore-mute-icon [width]="16" [height]="16"></bmcore-mute-icon>
    }
    @if (value > 0 && value <= 50) {
      <bmcore-volume-down-icon [width]="16" [height]="16"></bmcore-volume-down-icon>
    }
    @if (value > 50) {
      <bmcore-volume-up-icon [width]="16" [height]="16"></bmcore-volume-up-icon>
    }
  </bmcore-button>

  <div class="volume-control__slider-tooltip">
    <mat-slider min="0" max="100" step="1" bmTheme="sound-range">
      <input matSliderThumb [value]="value" (valueChange)="changeVolumeHandler($event)" />
    </mat-slider>
  </div>
</div>
